import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    width: '100%',
  },
  rowWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tableSubHeading: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.labraText.description,
  },
}))
